module.exports = __webpack_public_path__ + "static/media/植被场景监测装置2.c64288aa.jpg";